import { render } from "./AddUserActivity.vue?vue&type=template&id=6ec2e484&scoped=true"
import script from "./AddUserActivity.vue?vue&type=script&lang=js"
export * from "./AddUserActivity.vue?vue&type=script&lang=js"

import "./AddUserActivity.vue?vue&type=style&index=0&id=6ec2e484&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec2e484"]])

export default __exports__